import PropTypes from 'prop-types';
import React from 'react';
import PermissionsWrapper from '../../../containers/PermissionsWrapper';
import AddAppSiteButton from '../AddAppSiteButton';
import AppSitesTable from '../AppSitesTable';
import PageHeader from '../PageHeader';
import PartnerId from '../PartnerId';
import { partnerShape } from '../types';
import css from './BasePartnerAppSitesSummary.css';

export const SUMMARY_DATA_TEST_ID = 'app-sites-summary';

const BasePartnerAppSitesSummary = ({ partner, appFilter = '', agencyFilter = '', onAppSiteForPartner = () => {} }) => (
    <div className={css.appSitesSummary} data-testid={SUMMARY_DATA_TEST_ID}>
        <PageHeader partner={partner} />
        <div className={css.actionsRow}>
            <PartnerId partner={partner} />
            <PermissionsWrapper write requiredSingleAccessLevel>
                <AddAppSiteButton
                    className={css.addAppSiteButton}
                    partner={partner}
                    onAddAppSite={onAppSiteForPartner}
                />
            </PermissionsWrapper>
        </div>
        <AppSitesTable
            appFilter={appFilter}
            agencyFilter={agencyFilter}
            partner={partner}
            onAppSiteForPartner={onAppSiteForPartner}
        />
    </div>
);

BasePartnerAppSitesSummary.propTypes = {
    partner: partnerShape.isRequired,
    appFilter: PropTypes.string,
    agencyFilter: PropTypes.string,
    onAppSiteForPartner: PropTypes.func,
};

export default BasePartnerAppSitesSummary;
